import { Component, Injectable, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../authentication/services/auth.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { Author } from '../../../shared/models/Author';
import { PostService } from '../../../shared/services/post.service';
import { UrlService } from '../../../shared/services/url.service';
import { Sentiment } from '../../model/sentiment';
import { SentimentService } from '../../services/sentiment.service';
import { SentimentGroupService } from '../../services/sentimentgroup.service';
import { SentimentGroup } from '../../model/sentimentgroup';

import * as moment from 'moment-timezone';

@Component({
  selector: 'app-sentiment',
  templateUrl: '../templates/sentiment.component.html'
})
@Injectable()
export class SentimentComponent implements OnInit {
  title = 'Sentiment';
  DashboardUrl: string;
  IsEdition: boolean = false;
  CurrentLanguage: string;
  SentimentId: string;
  PostBody: string;
  SentimentGroups: SentimentGroup[] = [];

  Sentiment: Sentiment = {
    Id: "",
    PublicationDateUtc: null,
    Brief: "",
    Quote:"",
    SourceUrl: "",
    SentimentGroupId: "",
    IsBullish: false,
    IsActive: true,
    IsHighlighted: false,
    AuthorName: null,
    AuthorId: null
  };

  authorSelected: Author = {
    AuthorId: null,
    Name: ""
  };

  constructor(private activatedRoute: ActivatedRoute,
    private urlService: UrlService,
    private alertService: AlertService,
    private authService: AuthService,
    private sentimentService: SentimentService,
    private postService: PostService,
    private sentimentGroupService: SentimentGroupService) {
  };

  ngOnInit() {
    this.Init();
  };

  Init(): void {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.CurrentLanguage = this.authService.getActualLanguage().cultureNameISO;
    this.SentimentId = this.activatedRoute.snapshot.params.Id;
    this.IsEdition = Boolean(this.SentimentId);

    moment.tz.setDefault("UTC");

    this.sentimentGroupService.Get(this.CurrentLanguage)
      .subscribe(data => {
        this.SentimentGroups = data;
      });

    this.initModel();
  }

  authorChange (value: Author){
    this.authorSelected = value;
    this.Sentiment.AuthorName = value.Name;
    this.Sentiment.AuthorId = value.AuthorId;
  }

  private initModel() {
    if(this.IsEdition){
      this.sentimentService.GetById(this.CurrentLanguage, this.SentimentId)
        .subscribe(data => {
          if (data !== null) {
              this.Sentiment = data;
              this.authorSelected =
              {
                  Name: data.AuthorName,
                  AuthorId: data.AuthorId,
              };
          }
        });
    }
  }

  Save(form: FormGroup) {
    this.alertService.removeAll();
    window.scrollTo(0, 0);

    if (!form.valid) {
      this.alertService.add('danger', 'There are some errors in the form.');
      return;
    }

    if(this.IsEdition){
      this.sentimentService.Put(this.CurrentLanguage, this.SentimentId, this.Sentiment)
        .subscribe(
          () => this.alertService.add('success', 'Sentiment successfully edited'));
    }
    else{
      this.sentimentService.Post(this.CurrentLanguage, this.Sentiment)
        .subscribe(
          () => this.alertService.add('success', 'Sentiment successfully created'));
    }
    console.log(this.Sentiment);
  }

  onSourceUrlClick(){
    if(Boolean(this.Sentiment.SourceUrl)){
        this.postService.GetByUrl(this.Sentiment.SourceUrl, this.CurrentLanguage)
          .subscribe(data => {
              this.PostBody = data.HTML;
              this.authorSelected = {
                AuthorId: data.AuthorId,
                Name: ""
            };
            this.Sentiment.PublicationDateUtc = data.PublicationDate;
          });
    }
  }

  onDeleteClick() {
    this.sentimentService.Delete(this.CurrentLanguage, this.SentimentId)
      .subscribe(
        () => this.alertService.add('success', 'Sentiment successfully deleted'));
  }
}



// WEBPACK FOOTER //
// ./src/app/sentiment/components/scripts/sentiment.component.ts